module.exports = __webpack_public_path__ + "static/media/17.d82bbf96.jpg";